import { ref } from 'vue'

import { useJobsSdk } from '~/gql'
import type { CategoryType } from '~/gql/jobs/queries/getCategories/types'

export const useJobCategories = () => {
  const { getCategories } = useJobsSdk()
  const jobCategoriesLoading = ref(false)
  const jobCategories = ref<CategoryType[]>([])

  const fetchJobCategories = async () => {
    jobCategoriesLoading.value = true

    try {
      const res = await getCategories()

      jobCategories.value = res.data?.jobsCategories ?? []
    } finally {
      jobCategoriesLoading.value = false
    }
  }

  return {
    jobCategoriesLoading,
    jobCategories,
    fetchJobCategories,
  }
}
